<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات مقاله"
        >
          <b-form
            ref="blogform"
            @submit.prevent
          >
            <b-row>
              <b-col
                class="mt-2 form-size"
                md="8"
              >
                <b-row>
                  <b-tabs>

                    <b-tab title="اطلاعات">
                      <b-row class="mt-2">

                        <b-col
                          class="image"
                          cols="12"
                        >
                          <b-media class="mb-2">
                            <template #aside>
                              <b-avatar
                                ref="previewEl"
                                :src="Form.Image"
                                size="90px"
                                rounded
                                button
                                @click="$refs.refInputEl.click()"
                              />
                            </template>
                            <input
                              :ref="'refInputEl'"
                              type="file"
                              class="d-none"
                              name="Image"
                              @input="imageRenderer($event)"
                            >
                            <b-row>
                              <b-col md="12">
                                <b-form-group
                                  label="عنوان"
                                  label-for="Title"
                                  class="mb-0"
                                >
                                  <b-form-input
                                    id="Title"
                                    v-model="Form.Title"
                                    name="Title"
                                    autocomplete="off"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-media>
                        </b-col>

                        <b-col md="12">
                          <b-form-group
                            label="پیوند یکتا"
                            label-for="Slug"
                          >
                            <b-form-input
                              id="Sort"
                              v-model="Form.Slug"
                              name="Slug"
                              autocomplete="off"
                              dir="ltr"
                            />
                          </b-form-group>
                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="وضعیت"
                            label-for="IsActive"
                          >
                            <v-select
                              v-model="Form.IsActive"
                              :options="enums('IsActive')"
                              dir="rtl"
                              label="text"
                              name="IsActive"
                              :clearable="false"
                              :reduce="x => x.value"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="دسته بندی"
                            label-for="BlogCategoryId"
                          >
                            <z-blog-category
                              v-model="Form.BlogCategoryId"
                              :multiple="false"
                              :clearable="false"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="دسته بندی تور مرتبط"
                            label-for="TourCategoryId"
                          >
                            <z-tour-category
                              v-model="Form.TourCategoryId"
                              :multiple="true"
                              :clearable="true"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group
                            label="نویسنده"
                            label-for="Author"
                          >
                            <b-form-input
                              id="Author"
                              v-model="Form.Author"
                              name="Author"
                              autocomplete="off"
                            />
                          </b-form-group>

                        </b-col>

                        <b-col md="4">
                          <b-form-group
                            label="زمان مطالعه"
                            label-for="ReadingTime"
                          >
                            <b-input-group append="دقیقه">
                              <cleave
                                v-model="Form.ReadingTime"
                                class="form-control"
                                :raw="false"
                                :options="options"
                              />
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col cols="12">
                          <b-form-group
                            label="تگ ها"
                            label-for="Tag"
                          >
                            <b-form-tags
                              v-model="Form.Tag"
                              name="Tag"
                              placeholder=""
                              add-button-text="افزودن"
                              add-button-variant="outline-primary"
                            />
                          </b-form-group>
                        </b-col>


                        <z-seo v-model="Form" />

                      </b-row>
                    </b-tab>

                    <b-tab title="محتوا">
                      <b-row class="mt-2">
                        <b-col md="12">
                          <b-form-group
                            label-for="Description"
                          >
                            <z-quill-editor v-model="Form.Description" />
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-tab>

                  </b-tabs>

                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col
                    cols="12"
                    class="mt-1 mb-2 text-center"
                  >
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>

        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZBlogCategory from '@/tools/blogcategory.vue'
import ZTourCategory from '@/tools/tourcategory.vue'
import ZQuillEditor from '@/tools/quilleditor.vue'
import ZSeo from '@/tools/seo.vue'

export default {
  name: 'BlogDetails',
  components: {
    ZSeo,
    ZQuillEditor,
    ZBlogCategory,
    ZTourCategory,
  },
  data() {
    return {
      Schemas: [],
      Form: {
        Id: null,
        Title: null,
        MetaTitle: null,
        Description: null,
        Image: null,
        Video: null,
        IsActive: true,
        BlogCategoryId: null,
        TourCategoryId: [],
        Tag: [],
        ImageAlt: null,
        Slug: null,
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      GalleryFile: [],
      galleryId: 0,
      loading: false,
      showModalLinkAttr: false,
      elementTemp: null,
      blogFaqRemoveId: null,
      selectedFile: null,
      videoUrl: null,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.blog.add
      if (this.$route.params.id) {
        url = this.$api.blog.update
      }

      const formData = new FormData(this.$refs.blogform)

      formData.append('Id', this.Form.Id)
      formData.append('IsActive', this.Form.IsActive)
      formData.append('Description', this.Form.Description)

      if (this.Form.Video instanceof File) {
        formData.append('Video', this.Form.Video)
      }

      if (this.Form.BlogCategoryId) {
        formData.append('BlogCategoryId', this.Form.BlogCategoryId)
      }

      if (this.Form.TourCategoryId && this.Form.TourCategoryId.length) {
        this.Form.TourCategoryId.forEach(id => {
          formData.append('TourCategoryId', id)
        })
      }

      if (this.Form.ReadingTime) {
        formData.append('ReadingTime', this.Form.ReadingTime.replaceAll(',', ''))
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.blog.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
          this.Schemas = this.Form.Schemas
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },

    // باز کردن دیالوگ انتخاب فایل
    openFilePicker() {
      this.$refs.fileInput.click()
    },

    // مدیریت تغییر فایل
    handleFileChange(event) {
      const file = event.target.files[0]
      if (file && file.type.startsWith('video/')) {
        this.selectedFile = file
        this.Form.Video = URL.createObjectURL(file) // ایجاد URL برای نمایش فیلم
      } else {
        alert('لطفاً یک فایل ویدیویی انتخاب کنید.')
      }
    },

  },
}
</script>

<style scoped>

[dir=rtl] .input-group-url  {
  direction: ltr;
}

[dir=rtl] .input-group-url .input-group-prepend {
  margin-left: 0 !important;
  margin-right: -1px !important;
}

[dir=rtl] .input-group-url .input-group-text {
  border-top-left-radius: 0.357rem !important;
  border-bottom-left-radius: 0.357rem !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-left: 1px solid #d8d6de;
}

[dir=rtl] .input-group-url .form-control {
  border-top-right-radius: 0.357rem !important;
  border-bottom-right-radius: 0.357rem !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-right: 1px solid #d8d6de !important;
  padding: 0.438rem 1rem !important;
}

[dir=rtl] .input-group-url .form-control:focus-within {
  border-right: 1px solid #7367f0 !important;
}

.media {
  display: flex;
  align-items: flex-end;
}
.blog-video-box{
  line-height: 0px;
  padding: 0.438rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}

.blog-video-box video{
  border-radius: 0.357rem;
  width: 100%;
}
</style>
